import './GlobalStyles.scss'
function GlobalStyles({children}:{children:any}){
    return children 
}    
export default GlobalStyles